import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const RevealLines = ({ lines, className = "", delay = 0.3, as: Tag = "h1", testId }) => (
  <Tag className={className} data-testid={testId}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.06em]">
        <motion.span
          className="block"
          initial={{ y: "110%", rotate: 4 }}
          animate={{ y: "0%", rotate: 0 }}
          transition={{ duration: 1.1, ease, delay: delay + i * 0.12 }}
          style={{ transformOrigin: "left bottom" }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);
